
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kredit-tv",
      function () {
        return require("private-next-pages/kredit-tv.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kredit-tv"])
      });
    }
  